import {
  HotelCardRatingPropertiesType,
  RatingResults
} from "@website/accommodation-ui/hotel-card-new/hotel-card-info/hotel-card-rating/hotel-card-rating.types";
import { isFilled } from "@website/utils/is-filled";
import { numberConvert } from "@website/utils/number-convert";
import { useCompatRouter } from "@website/widget-v2/helpers/compat-router.hook";
import { RatingDefaults } from "@website/widget/reserve-rate";
import clamp from "lodash-es/clamp";
import pick from "lodash-es/pick";
import { useMemo } from "react";

const ratingDefaults: RatingDefaults = [
  { minRate: 0, text: "", color: "default" },
  { minRate: 2, text: "", color: "default" },
  { minRate: 3, text: "", color: "default" },
  { minRate: 3.5, text: "خوب", color: "default" },
  { minRate: 4, text: "خیلی خوب", color: "success" },
  { minRate: 4.5, text: "عالی", color: "success" }
];
const isNewLimit = 5;

export const getTextAndColorFromHotelRating = (
  rating: number,
  reviewCount: number
): RatingResults => {
  const clampedRate = clamp(rating, 0, 5);
  if (isFilled(reviewCount) && reviewCount < isNewLimit) {
    return {
      clampedRate,
      text: "جدید",
      color: "secondary",
      isNew: true
    } as const;
  }
  const results = {
    clampedRate,
    isNew: false,
    ...pick(
      ratingDefaults.filter((item) => clampedRate >= item.minRate).pop() ||
        ratingDefaults[0],
      ["text", "color"]
    )
  };
  return results;
};

export const useHotelCardRating = (
  properties: HotelCardRatingPropertiesType
) => {
  const router = useCompatRouter();
  const { rating, reviewCount } = properties;
  const {
    shouldRender,
    color: badgeColor,
    text: badgeText,
    labelText
  } = useMemo(() => {
    const { clampedRate, isNew, color, text } = getTextAndColorFromHotelRating(
      rating as number,
      reviewCount as number
    );

    return {
      shouldRender: clampedRate >= 0,
      color,
      text: isNew
        ? text
        : `${numberConvert(clampedRate, {
            locale: router.locale
          })}`,
      labelText: isNew ? undefined : text
    };
  }, [properties.size, rating, reviewCount, router.locale]);

  return {
    shouldRender,
    reviewCount,
    badgeColor,
    badgeText,
    labelText
  };
};
